<template>
  <div>
    <label class="d-block mb-2" :for="id">
      {{ label }}
      <info-tooltip class="ml-1" v-if="tooltipContent">{{ tooltipContent }}</info-tooltip>
    </label>

    <div class="dimension-input">
      <input
        type="number"
        class="form-control"
        :id="id"
        :min="min"
        :max="max"
        :value="value"
        :placeholder="placeholder"
        step="1"
        @change="onChange"
        @keyup="onKeyup"
      >
      <div class="dimension-input__unit" v-if="unit">
        {{ unit }}
      </div>
    </div>
  </div>
</template>

<script>
import InfoTooltip from '../InfoTooltip';
export default {
  components: { InfoTooltip },
  props: {
    value: {
      type: [String, Number],
    },
    id: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    label: {
      type: String,
      required: true,
    },
    unit: {
      type: String,
    },
    placeholder: {
      type: String,
    },
  },

  computed: {
    tooltipContent() {
      if (!this.min && !this.max) {
        return null;
      }

      const unit = typeof this.unit !== 'undefined' ? this.unit : '';

      if (this.min && !this.max) {
        return `${this.i18n.tooltip_minimum} ${this.min} ${unit}`;
      }

      if (!this.min && this.max) {
        return `${this.i18n.tooltip_maximum} ${this.min} ${unit}`;
      }

      return this.i18n.tooltip_minimum_and_maximum
        .replace('%0', `${this.min} ${unit}`)
        .replace('%1', `${this.max} ${unit}`);
    },
  },

  methods: {
    onChange(event) {
      this.$emit('change', event);
    },

    onKeyup(event) {
      this.$emit('keyup', event);
    },
  },
};
</script>

<style scoped>
.dimension-input {
  position: relative;
}

.dimension-input__unit {
  position: absolute;
  right: .75rem;
  top: 0;
  line-height: 2.5rem;
  pointer-events: none;
}

.dimension-input .form-control::-webkit-outer-spin-button,
.dimension-input .form-control::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.dimension-input .form-control[type=number] {
  -moz-appearance: textfield;
}
</style>
